<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="book-one">
<h1 style="font-family: Arial; margin-top: 150px;">Book One</h1>
<p><span style="text-docoration: underline;"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?bb2675aa